export * from "@repo/ui/gailgpt/mutation-proposal";
